import React from 'react';
import classNames from 'classnames';

import css from './Icons.module.css';

const IconFarmToForkDining = props => {
  const { className } = props;
  const classes = classNames(className, css.root);

  return (
    <svg className={classes} xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 85 85">
      <g fill="none" stroke="#394553" strokeLinecap="round" strokeMiterlimit={10} strokeWidth={3}>
        <path
          strokeLinejoin="round"
          d="m23.259 10.136-.001 22.57a4.077 4.077 0 0 0 4.066 4.066h2.034v37.206c0 1.649 1.578 3 3.228 3 1.649 0 3.228-1.351 3.228-3l-.001-37.206h2.034a4.08 4.08 0 0 0 4.066-4.066l-.002-22.571"
        />
        <path d="M29.465 27.677V10.313M35.705 27.677l.002-17.364" />
        <path
          strokeLinejoin="round"
          d="m61.725 47.738-.02-35.787c-.039-2.271.074-4.52-1.777-3.791 0 0-4.92 1.641-5.797 6.309L51.445 43.39l3.604 1.848.064 28.686c.002 1.68 1.667 3.053 3.343 3.051 1.678 0 3.284-1.375 3.286-3.053l-.017-26.184z"
        />
      </g>
    </svg>
  );
};

export default IconFarmToForkDining;
